import React from 'react';
import { string, oneOf } from 'prop-types';
import ClassNames from 'classnames';
import PaymentIconLibrary from './PaymentIconLibrary';

import './PaymentIcon.scss';

const PaymentIcon = ({ className, icon, id, size }) => {
  const classnames = ClassNames(
    'payment-icon',
    className,
    `payment-icon--${size}`
  );

  const SvgIcon = PaymentIconLibrary[icon];

  return <SvgIcon id={id} className={classnames} />;
};

PaymentIcon.propTypes = {
  className: string,
  icon: oneOf([
    'atome',
    'aubLight',
    'bdo',
    'bdoLight',
    'billease',
    'bpi',
    'bpiLight',
    'cebuana',
    'cebuanaLight',
    'coins',
    'coinsLight',
    'crypto',
    'gcash',
    'googlepay',
    'grabpay',
    'grabpayLight',
    'landbank',
    'landbankLight',
    'mastercard',
    'maya',
    'mayaLight',
    'metrobank',
    'metrobankLight',
    'mlhuillier',
    'mlhuillierLight',
    'otc',
    'paylaterLight',
    'paylaterLightWithTag',
    'paymongo',
    'pineLabsPayInInstallments',
    'qrph',
    'rbank',
    'rbankLight',
    'rcbc',
    'rcbcLight',
    'securityBank',
    'securityBankLight',
    'sevenEleven',
    'sevenElevenLight',
    'shopeepay',
    'stripe',
    'stripeLight',
    'ubp',
    'ubpLight',
    'unionbank',
    'visa',
    'visaLight',
    'visaMastercard'
  ]).isRequired,
  id: string,
  size: oneOf(['sm', 'lg'])
};

PaymentIcon.defaultProps = {
  className: undefined,
  id: undefined,
  size: 'sm'
};

export default PaymentIcon;
